// extracted by mini-css-extract-plugin
export default {"toolTipContent":"ButtonDownloadReceipt_toolTipContent__DCm63","arrow":"ButtonDownloadReceipt_arrow__FWeuE"};